export const environments = {
  COUNTRY: 'countryside',
  MOUNTAIN: 'mountain',
  FOREST: 'forest',
  SHORE: 'shore',
}
